import React from "react";
import Pill from "./PillElement";

export const HiddenFromItineraryPill = () => {
  return <Pill
    color="pink"
    label={RESX.FreeField.HiddenFromItinerary}
  />
}